import Table from '@tiptap/extension-table';

export default Table.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                parseHTML: (element) => element.style?.cssText,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
